<div class="grid-x">
  <div class="cell small-12">
    <h4 class="epsilon small">
      Import Entity Map File
    </h4>
  </div>
  <div class="cell small-8 margin-bottom">
    <input type="file" name="mapFile" id="mapFile" (change)="fileChanged($event.target.files)" title=" " />
    <label class="display-inline-block" for="mapFile" #uploadedMaps></label>
  </div>
  <div class="cell small-4 margin-bottom">
    <button class="button hollow" (click)="reset()">Reset Uploaded Files</button>
  </div>
  @for (error of errors; track error) {
    <div class="cell small-12 bold red">
      {{error}}
    </div>
  }

  @if (parsedMaps && parsedMaps.length > 0) {
    <div class="cell small-12">
      {{uploadFileName}}
    </div>
    @if (parsedMaps.length === 0) {
      <div class="cell small-12">
        File contains no entity maps.
      </div>
    }
    @for (map of parsedMaps; track map) {
      <div class="cell small-6 small-font-size">
        Map Name : {{map.mapName}}
      </div>
      <div class="cell small-6 small-font-size">
        Entity Type: @if (map.entity) {
        {{map.entity.entityName}}
      }
    </div>
    @if (map.relatedEntityMaps.length > 0) {
      <div class="cell small-12 padding-left small-font-size">
        Related Entity Maps:
      </div>
      @for (related of map.relatedEntityMaps; track related) {
        <div class="cell small-4 padding-left small-font-size">
          Map Name: {{related.mapName}}
        </div>
        <div class="cell small-4 small-font-size">
          Entity Type: @if (related.entity) {
          {{related.entity.entityName}}
        }
      </div>
      <div class="cell small-4 small-font-size">
        Related to {{map.mapName}} via {{related.relationalProperty}}
      </div>
    }
  }
}
@if (parsedMaps.length > 0) {
  <div class="cell small-12">
    <button class="button hollow" (click)="saveImportedMaps()">Save Imported Maps</button>
  </div>
}
}
</div>
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
